export const GET_SIGNALR_TOKEN = '/api/Notification/GetSignalRToken';
export const COMMON_MESSAGES = {
  DATE_YYYY_MM_DD: 'YYYY-MM-DD',
  DATE_DD_MMM_YYYY: 'DD MMM YYYY',
  ERROR: 'Something went wrong, please contact to your system administrator.',
  MAX_LENGTH_100: 'Maximum length should be 100 characters',
  MAX_LENGTH_50: 'Maximum length should be 50 characters',
  MAX_LENGTH_20: 'Maximum length should be 20 characters',
  MAX_LENGTH_10: 'Maximum length should be 10 characters',
  ACTIVE: 'Are you sure you want to activate',
  INACTIVE: 'Are you sure you want to inactive',
  ALPHA_NUMERIC_ONLY: 'The value must contain only alphanumeric characters.',
};

export const PATTERN_ALPHA_NUMERIC_ONLY = /^[a-zA-Z0-9]+$/;
export const UK_TIME_ZONE = 'Europe/London';
export const CET_TIME_ZONE = 'Europe/Paris'; // CET (UTC+1) / CEST (UTC+2) — handles DST automatically

export const NUMBERS = {
  POINT_SIX: 0.6,
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  THREE_POINT_SIX: 3.6,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7,
  EIGHT: 8,
  NINE: 9,
  TEN: 10,
  ELEVEN: 11,
  TWELVE: 12,
  THIRTEEN: 13,
  FOURTEEN: 14,
  FIFTEEN: 15,
  SEVENTEEN: 17,
  EIGHTEEN: 18,
  NINETEEN: 19,
  TWENTY: 20,
  TWENTY_ONE: 21,
  TWENTY_TWO: 22,
  TWENTY_THREE: 23,
  TWENTY_FOUR: 24,
  TWENTY_FIVE: 25,
  TWENTY_SIX: 26,
  TWENTY_SEVEN: 27,
  TWENTY_EIGHT: 28,
  THRITY: 30,
  THRITY_ONE: 31,
  THRITY_TWO: 32,
  THRITY_THREE: 33,
  THRITY_SEVEN: 37,
  THRITY_EIGHT: 38,
  THIRTY_NINE: 39,
  FOURTY: 40,
  FOURTY_TWO: 42,
  FOURTY_THREE: 43,
  FIFTY: 50,
  SIXTY: 60,
  SEVENTY: 70,
  SEVENTY_TWO: 72,
  EIGHTY: 80,
  NINETY: 90,
  HUNDREDS: 100,
  ONE_THIRTY: 130,
  ONE_THIRTY_NINE: 139,
  ONE_FIFTY: 150,
  ONE_FIFTY_ONE: 151,
  ONE_SIXTY: 160,
  ONE_SIXTY_FIVE: 165,
  ONE_SIXTY_NINE: 169,
  ONE_SEVENTY_TWO: 172,
  ONE_EIGHTY_ONE: 180,
  TWO_HUNDREDS: 200,
  TWO_FIFTY: 250,
  TWO_SIXTY: 260,
  TWO_SEVENTY: 270,
  FIVE_HUNDREDS: 500,
  NINE_NINETY_NINE: 999,
  THOUSAND: 1000,
  MILLION: 1000000,
  THERMAL_CONVERSION_FACTOR: 34.1214,
  THERMS_KWH_CONVERSION: 29.3071,
  TJ_CONVERSION: 0.0000036,
  THERMS_GWH_CONVERSION: 0.0000293071,
  THERMS_TJ: 0.00010550559,
  THERMS_MWh_CONVERSION: 0.0293071,
  MWH_TJ_CONVERSION: 0.0036,
};

export const PAGINATION_OPTIONS = {
  FIVE_TO_FIFTY: [
    NUMBERS.FIVE,
    NUMBERS.TEN,
    NUMBERS.TWENTY,
    NUMBERS.THRITY,
    NUMBERS.FOURTY,
    NUMBERS.FIFTY,
  ],
  FIVE_TO_TWO_FIFTY: [
    NUMBERS.FIVE,
    NUMBERS.TEN,
    NUMBERS.TWENTY,
    NUMBERS.FIFTY,
    NUMBERS.HUNDREDS,
    NUMBERS.TWO_FIFTY,
  ],
  FIVE_TO_HUNDREDS: [
    NUMBERS.FIVE,
    NUMBERS.TEN,
    NUMBERS.TWENTY,
    NUMBERS.THRITY,
    NUMBERS.FOURTY,
    NUMBERS.FIFTY,
    NUMBERS.SIXTY,
    NUMBERS.SEVENTY,
    NUMBERS.EIGHTY,
    NUMBERS.NINETY,
    NUMBERS.HUNDREDS,
  ],
};

export const HTTPS_STATUS_CODES = {
  SUCCESS: 200,
  FORBIDDEN: 403,
};

// check permissons
export const applicationName = {
  /** Genesis */
  genesis: 'Genesis',
  genesisAdmin: 'Genesis-Admin',
};

export const userRole = {
  readOnly: 'ReadOnly',
  readWrite: 'ReadWrite',
  noAccess: 'NoAccess',
};

export const ERR_CODE_401 = 401;
export const ERR_CODE_403 = 403;
export const ERR_CODE_400 = 400;
export const ERR_CODE_500 = 500;

export const INTERVAL_TIME_60000 = 60000;
export const INTERVAL_TIME_120000 = 120000;
